import { $t } from '@/utils/languageAuto';

var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', [_c('my-modal', {
    attrs: {
      "width": 800,
      "title": _vm.t('申请开票'),
      "data-sign": "finance_reconciliation_bill_apply_modal"
    },
    on: {
      "cencel": _vm.handleClose
    },
    model: {
      value: _vm.visible,
      callback: function ($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c('p', {
    class: {
      'mb-0': _vm.billType === _vm.$enum.common.BoolIntEnum.NO,
      'mb-10': _vm.billType === _vm.$enum.common.BoolIntEnum.YES
    }
  }, [_vm._v(_vm._s(_vm.t($t("\u5171") + _vm.count + $t("\u4E2A\u5BF9\u8D26\u5355\uFF0C\u4E00\u4E2A\u5BF9\u8D26\u5355\u53EA\u80FD\u7533\u8BF7\u5F00\u4E00\u6B21\u53D1\u7968\uFF0C\u5E94\u5F00\u7968\u91D1\u989D\u5982\u4E0B\uFF0C\u8BF7\u786E\u8BA4"))))]), _vm.billType === _vm.$enum.common.BoolIntEnum.NO ? _c('div', {
    staticClass: "mb-5",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.t('汇总人民币金额')) + _vm._s(_vm.tc('：')))]), _vm.rmbAmountLoading ? _c('a-icon', {
    staticClass: "ml-5",
    attrs: {
      "type": "loading"
    }
  }) : _c('span', {
    staticClass: "ml-5"
  }, [_vm.totalRmbAmount ? _c('span', [_vm._v(_vm._s(_vm.totalRmbAmount) + " RMB")]) : _c('span', [_vm._v("--")])])], 1) : _vm._e(), _c('a-skeleton', {
    attrs: {
      "active": "",
      "loading": _vm.loadingStatus
    }
  }, [_c('my-table', {
    attrs: {
      "bordered": "",
      "columns": _vm.columns,
      "data-source": _vm.tbodyData,
      "row-key": function () {
        return 1;
      }
    }
  })], 1), _c('div', {
    staticClass: "fill-data mt-20 mb-10"
  }, [_c('span', [_vm._v(_vm._s(_vm.t('开票资料')))]), !_vm.hasBillData && !_vm.billDataLoading ? _c('a-button', {
    directives: [{
      name: "permission",
      rawName: "v-permission",
      value: '/finance/bill_data',
      expression: "'/finance/bill_data'"
    }],
    attrs: {
      "type": "primary",
      "ghost": "",
      "fbu-analyse-name": $t("\u7EF4\u62A4\u5F00\u7968\u8D44\u6599")
    },
    on: {
      "click": _vm.handleAddBillData
    }
  }, [_vm._v(_vm._s(_vm.t('维护开票资料')))]) : _vm._e()], 1), _c('a-skeleton', {
    attrs: {
      "active": "",
      "loading": _vm.billDataLoading
    }
  }, [_c('my-table', {
    ref: "billData",
    attrs: {
      "data-sign": "finance_reconciliation_bill_data_list",
      "bordered": "",
      "columns": _vm.billDataColumns,
      "data-source": _vm.billData,
      "row-key": function () {
        return 1;
      }
    }
  })], 1), _c('div', {
    staticClass: "mt-20 mb-5"
  }, [_vm._v(_vm._s(_vm.t('备注')))]), _c('my-textarea', {
    attrs: {
      "rows": 5,
      "placeholder": _vm.t("温馨提示:\n1、开票申请提交后,无填写备注的将会直接推送完成开票;如有特殊开票需求请填写备注。\n2、本次开票申请应开票金额为0或负数无法开票。\n"),
      "maxLength": 255
    },
    model: {
      value: _vm.customerRemark,
      callback: function ($$v) {
        _vm.customerRemark = $$v;
      },
      expression: "customerRemark"
    }
  }), _vm.tips.length ? _c('list-tips', {
    staticClass: "mt-20",
    attrs: {
      "tips": _vm.tips
    }
  }) : _vm._e(), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('a-button', {
    staticClass: "mr-10",
    attrs: {
      "data-sign": "finance_reconciliation_bill_modal_close",
      "fbu-analyse-name": $t("\u53D6\u6D88")
    },
    on: {
      "click": _vm.handleClose
    }
  }, [_vm._v(_vm._s(_vm.t('取消')))]), [!_vm.hasBillData || Number(_vm.totalRmbAmount) <= 0 && _vm.billType === _vm.$enum.common.BoolIntEnum.NO || _vm.isShowZeroTip ? _c('a-popover', [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [!_vm.hasBillData ? _c('div', [_vm._v(_vm._s(_vm.t('请先维护开票资料')))]) : _vm._e(), Number(_vm.totalRmbAmount) <= 0 && _vm.billType === _vm.$enum.common.BoolIntEnum.NO || _vm.isShowZeroTip ? _c('div', [_vm._v(_vm._s(_vm.zeroTip))]) : _vm._e()]), _c('a-button', {
    attrs: {
      "type": "primary",
      "disabled": true,
      "data-sign": "finance_reconciliation_bill_apply_save",
      "fbu-analyse-name": $t("\u4FDD\u5B58")
    },
    on: {
      "click": _vm.handleOk
    }
  }, [_vm._v(_vm._s(_vm.t('保存')))])], 1) : _c('a-button', {
    attrs: {
      "data-sign": "finance_reconciliation_bill_apply_save",
      "type": "primary",
      "fbu-analyse-name": $t("\u4FDD\u5B58")
    },
    on: {
      "click": _vm.handleOk
    }
  }, [_vm._v(_vm._s(_vm.t('保存')))])]], 2)], 1)], 1);
};

var staticRenderFns = [];
export { render, staticRenderFns };